import { render, staticRenderFns } from "./PacBioSection.vue?vue&type=template&id=d4c0f12e"
import script from "./PacBioSection.vue?vue&type=script&lang=ts"
export * from "./PacBioSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports